import { ReactNode } from 'react';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Disable default styles globally

const useToast = () => {
  const successToast = (message: ReactNode) => {
    toast(
      <div className="grid grid-cols-[20px,_1fr] items-center gap-4 z-[10000] bg-secondary-50 text-secondary-700">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_326_74959)">
            <path d="M18.3332 9.23336V10C18.3321 11.797 17.7503 13.5456 16.6743 14.9849C15.5983 16.4242 14.0859 17.4771 12.3626 17.9866C10.6394 18.4961 8.79755 18.4349 7.1119 17.8122C5.42624 17.1894 3.98705 16.0384 3.00897 14.5309C2.03089 13.0234 1.56633 11.2401 1.68457 9.44696C1.80281 7.65383 2.49751 5.94697 3.66507 4.58092C4.83263 3.21488 6.41049 2.26285 8.16333 1.86682C9.91617 1.47079 11.7501 1.65198 13.3915 2.38336" stroke="#439F6E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.3333 3.33331L10 11.675L7.5 9.17498" stroke="#439F6E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_326_74959">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
        {message}
      </div>,
      { bodyClassName: 'bg-secondary-50 shadow-md border-l-4 border-secondary-300 rounded-lg font-medium' }
    );
  };

  const errorToast = (message: ReactNode) => {
    toast(
      <div className="grid grid-cols-[20px,_1fr] items-center gap-4 z-[10000] bg-rose-50">
        <span> ❌</span> {message}
      </div>,
      { bodyClassName: 'bg-rose-50 shadow-md rounded-lg font-medium text-red-800 border-l-4 border-red-400' }
    );
  };

  const warningToast = (message: ReactNode) => {
    toast(
      <div style={{ background: '#fdfdea ' }} className="grid grid-cols-[20px,_1fr] items-center gap-4 z-[10000] bg-yellow-50">
        <span> ⚠️ </span> {message}
      </div>,
      {
        bodyClassName: 'bg-yellow-50 shadow-md text-yellow-800 border-l-4 border-yellow-400 rounded-lg font-medium',
        className: 'bg-yellow-50 !important', // Ensure background is forced
      }
    );
  };

  return { successToast, errorToast, warningToast };
};

export default useToast;
